import {
  normalizeDmVatTuLine,
  type DinhMucCoDinhCreateRequest,
  type DinhMucCoDinhDmVatTuInput,
  type DinhMucCoDinhFormFields,
  type DinhMucCoDinhUpdateRequest,
  type DinhMucCoDinhVatTuLineDraft,
} from '@/types/dinh-muc-co-dinh';

interface BuildPayloadOptions {
  dinhMucCoDinh: DinhMucCoDinhFormFields;
  lines: DinhMucCoDinhVatTuLineDraft[];
}

export function filterDmVatTuLines(
  lines: DinhMucCoDinhVatTuLineDraft[]
): DinhMucCoDinhDmVatTuInput[] {
  return lines
    .map(normalizeDmVatTuLine)
    .filter((item): item is DinhMucCoDinhDmVatTuInput => item !== null);
}

export function buildDinhMucCoDinhCreatePayload(
  options: BuildPayloadOptions
): DinhMucCoDinhCreateRequest {
  return {
    dinhMucCoDinh: options.dinhMucCoDinh,
    dmVatTu: filterDmVatTuLines(options.lines),
  };
}

export function buildDinhMucCoDinhUpdatePayload(
  options: BuildPayloadOptions
): DinhMucCoDinhUpdateRequest {
  return {
    dinhMucCoDinh: options.dinhMucCoDinh,
    dmVatTu: filterDmVatTuLines(options.lines),
  };
}

export type { DinhMucCoDinhVatTuLineDraft };
